<template>
  <div>
    <div class="row">
      <div class="col-md-6 mr-3">
        <SelectIconGroup
          idInput="schemaModal"
          iconInput="fa-lock"
          labelInput="Auto Escola"
          :optionsInput = optionsCFCModal
          :optionSelected="optionSelectedCFCModal"
        >
          &nbsp;
        </SelectIconGroup>
      </div>
        <div class="row">
          <div div class="col-md-6">
            <button class="btn  btn-micro" type="button" @click="addList()">Adicionar</button>
          </div>
        </div>
    </div>

    <div class="row">
      <div class="list-group col-md-12" v-for="item in listCFC">
        <div class="container-fluid">
          <p class="list-group-item list-group-item-action active d-flex flex-row justify-content-between"> 
            <span class="text-white"  > {{ item.value }} </span>
            <a class="btn btn-micro btn-danger" :value = item.id aria-label="Delete" @click="removeList(item.id)"><i class="fa fa-trash-o" aria-hidden="true"></i></a>
          </p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <form class="form-inline">
          <div class="form-group mx-sm-3 mb-2">
            <input type="password" id="password" name="password" required="required"/>
            <label class="control-label" for="password">Informe sua Senha </label><i class="bar"></i>
            <small id="emailHelp" class="form-text text-muted">A senha deve conter 8 caracteres</small>
          </div>
          <button class="btn btn-micro btn-primary" type="button" @click="save"> Salvar</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import SelectIconGroup from "@/vuestic-theme/vuestic-components/vuestic-input/SelectIconGroup";
import UsuariosController from "./../UsuariosController";
import urlApi from "../../../router/urlApi";

export default {
  name: "addUserToCfC",
  components: {
    SelectIconGroup,
  },
  props: ["data"],

  data() {
    return {
      download: {
        load: false
      },
      userData: {},
      listCFC : [],
      preList : [],
      optionSelectedCFCModal : '',
      optionsCFCModal: [{
        id: '',
        value: 'Selecione uma autoescola'
      }]
    };
  },
  methods: {
    addList() {
      const selectedCFC =  document.getElementById('schemaModal').value
      const selectedCFCValue = document.querySelector('#schemaModal').selectedOptions[0].text
      if (this.listCFC.find(  item => item.id === selectedCFC ) ) {
          return this.$toasted.show('CFC já selecionado', {position: 'top-right'} )
        }
      
      if (selectedCFC) this.listCFC.push( {id: selectedCFC , value:selectedCFCValue } )
    },

    async creatList ( ) {
      const results = await UsuariosController.getSchemasByUser( this.userData.id_usuario )

      let listDate = this.optionsCFCModal.filter(  item => results.includes(item.id)  )
      
      this.listCFC = listDate
      this.preList = await UsuariosController.getSchemasByUser( this.userData.id_usuario )

      let nodelist  = this.preList.map( item  => document.querySelector(`a[value=${item}]`) );
    
      nodelist.forEach( element => element.classList.add("disabled") )

    },

    save() {
      let ids =  this.listCFC.map(element => element.id)
      let senha = document.querySelector(`[name=password]`).value.trim()

      if (senha.length < 8 ) return this.$toasted.show('a senha deve ter 8 caracteres', {position: 'top-right'} ) ; 

      UsuariosController.saveSchemasList(ids , senha , this.userData.id_usuario)
    },

    removeList( item ) {

      if (!this.preList.includes( item ) ) {
        let index = this.listCFC.findIndex(array => array === item )
        this.listCFC.splice(index, 1)
        return this.$toasted.show('CFC foi excluido', {position: 'top-right'} )
      }
      return this.$toasted.show('CFC Não pode ser excluído', {position: 'top-right'} )
    }
  },
  async mounted() {
    let self = this;

    self.optionSelectedCFCModal = self.userData.schema

    let idUser = self.$route.params.idUsuario

    let dadosUser = await UsuariosController.getUserById( idUser )

    self.userData = dadosUser

    self.creatList()
   
    UsuariosController.getAutoEscolas(function(data) {
      if (data.length > 0) {
        data.map(function(value) {
          self.optionsCFCModal.push({
            id: value.tenant_schema,
            value: value.nome_fantasia
          });
        });
      } else {
        self.optionsCFC = [
          { id: "Cadastre uma AutoEscola!", value: "Cadastre uma AutoEscola!" }
        ];
      }
    });
  }
};
</script>
